const ROUTES = Object.freeze({
    LOGIN: '/login',
    REGISTER: '/register',
    RECOVER: '/recover-password',
    VERIFY_EMAIL: '/verify-email',

    HOMEPAGE: '/',
    TRADES: '/trades',
    SALES: '/sales',
    REQUISITIONS: '/requisitions',

    FINANCE_REQUISITIONS: '/finance/requisitions',

    FARMERS: '/farmers',
    STORAGE: '/storage',
    HUBS: '/hubs',
    ONLINE: '/online-sales',
    CONTRIBUTION_MARGIN: '/contribution-margin',
    LOCATIONS_CM2: '/locations-cm2',
    INVENTORY: '/inventory',
    RETAIL_DELIVERIES: '/retail-deliveries',
    HUBS_MONTHLY_SALES: '/hubs-monthly-sale',
    AI: '/ai',

    PROFILE: '/profile',

    // LOGISTICS
    SUPPLY_TRADES: '/supply-trades',
    ASSETS: '/assets',
    DELIVERIES: '/deliveries',
    EXPENSES: '/expenses',
    MAINTENANCE: '/maintenance',
    ROUTE_PLANS: '/route-plans',

    // HUBS
    HUB: '/hub/:hub',
    HUB_SALES: '/hub/:hub/sales',
    HUB_INVENTORY: '/hub/:hub/inventory',
    HUB_RESTOCK: '/hub/:hub/restock',
    HUB_DELIVERIES: '/hub/:hub/deliveries',
});

export default ROUTES;
